import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'

Vue.use(VueProgressBar, {
  color: 'hsl(204, 86%, 53%)',
  failedColor: 'red',
  height: '1px'
})



// WEBPACK FOOTER //
// ./src/progress/index.js